import { Trans, useTranslation } from "react-i18next";
import InputText from "../../components/shared/input-text/component";
import { Helmet } from "react-helmet";
import Button from "../../components/shared/button/component";
const LSForgetPassword = ({ emailError, emailErrorMsg, emailSuccess, email, onemailChange, onSubmitClickHandler }) => {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <meta name="description" content={t("forgot_password.ls.description_meta")} />
        <title>{t("page_title.ls.forgot_password")}</title>
      </Helmet>
      <section className="main-content">
        <div className="container mx-auto">
          <div
            className="form-wrap border border-[#FF6600] rounded-[10px]  !p-4 md:!p-10 gap-5 shadow-[4px_4px_10px_0px_#0000000D]"
            style={{ fontFamily: '"Poppins", sans-serif' }}
          >
            <div className="form-container">
              <hgroup className="text-center user-page">
                <div>
                  <h1 className="text-[#16283D] font-rethink text-2xl md:text-4xl font-bold mt-0">
                    {t("forgot_password.ls.headline")}
                  </h1>

                  <p className="form-signin-heading text-center font-rethink !text-base md:!text-lg !text-[#16283D] !mt-4 !mb-6 font-semibold">
                    {t("forgot_password.ls.content")}
                  </p>
                </div>
              </hgroup>
              <div className="form-group text-center">
                <div className="form-text mb-2">
                  {emailError && (
                    <p key="pswrdErr" role={alert} className="alert error  text-red-600 ">
                      <p className="text-sm"> {t("forgot_password.ls.email_error_alert")}</p>
                    </p>
                  )}

                  {emailSuccess && (
                    <p key="pswrdErr" role={alert} className="alert error text-red-600 text-sm w-full">
                      <h4> {t("forgot_password.ls.forget_success_alert")}</h4>
                    </p>
                  )}
                </div>
                <div>
                  <InputText
                    showLabel={false}
                    required="required"
                    id="email"
                    type="email"
                    className=" border-gray-300 rounded p-3 border mb-4 max-w-96 !font-rethink"
                    name="email"
                    value={email}
                    maxLength={100}
                    onChange={onemailChange}
                    placeholder={t("forgot_password.ls.placeholder_email")}
                  />
                </div>
                <p className="text-[#424a5c] !text-[14px] !text-normal !leading-[1.4] !px-0 md:!px-5">
                  {t("forgot_password.ls.sub_content")}
                </p>
              </div>

              <div className="align-center fbn bounce-effect md:relative bottom-0 left-0 bg-white  border-gray-300 p-2 md:p-3 lg:p-3 text-center w-full z-50">
                <Button
                  isLoading={false}
                  disabled={false}
                  type="submit"
                  id="forgotPasswordButton"
                  className="rounded-full bg-[#16283D] items-center justify-center py-4 px-[46px] text-center text-xs max-[340px]:text-[10px] md:text-lg font-bold text-white font-rethink uppercase mt-4"
                  onClick={onSubmitClickHandler}
                  ctaText={t("forgot_password.ls.btn_cta")}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default LSForgetPassword;
